import { Correlative, CorrelativeCreate } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { correlativePaths } from "services/services.paths";

export const getCorrelativesByBranch = async (branchId: string) => {
  const response = await get<Correlative[]>(
    correlativePaths.getByBranch + `${branchId}`
  );

  return response.data;
};

export const removeCorrelaitve = async (id: number) => {
  const response = await remove<any>(correlativePaths.delete + `/${id}`);

  return response;
};

export const createCorrelative = async (correlative: CorrelativeCreate) => {
  const response = await post<any>(correlativePaths.post, correlative);

  return response;
};

export const updateCorrelative = async (
  correlative: CorrelativeCreate,
  correlativeId: string
) => {
  const response = await patch<any>(
    correlativePaths.put + `/${correlativeId}`,
    correlative
  );

  return response;
};
